
angular.module('trainerWebApp.resources')
  .factory('courseTraineesResource', ['$resource', 'errorHandler', '$window', 'mtypes', function ($resource, errorHandler, $window, mtypes) {

    var TraineesResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/course/:courseId/:type');
    var TraineesDeleteResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/course/:courseId/:type/action/delete');
    var TraineesWithStateResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/course/:courseId/:type/:state');
    var TraineeResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/course/:courseId/trainee/:traineeId/:type');
    var CourseMicroServiceResource = $resource(mfConfig.cModuleSeriesBaseUrlSegment + '/course/:courseId/:action');
    var CourseBulkMicroServiceResource = $resource(mfConfig.cModuleSeriesBaseUrlSegment + '/courses/:action', null, {
      'update': {method: 'PUT'}
    });
    var CourseTraineeInviteResoure = $resource(mfConfig.cModuleSeriesBaseUrlSegment + '/course/invite');
    var CourseMicroServiceTraineesByStateResource = $resource(mfConfig.courseSeriesBaseUrlSegment + '/course/:courseId/:action/:state');

    // Trainees page
    TraineesResource.prototype.traineesSetup = function traineesSetup(courseId, resultCb, errorCb) {
      return TraineesResource.get({courseId: courseId, type: 'trainees-setup'}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    TraineesResource.prototype.getAllTraineesInACourse = function getAllTraineesInACourse(courseId, resultCb, errorCb) {
      return TraineesResource.get({courseId: courseId, type: 'trainee'}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    // Add Trainees page
    TraineesResource.prototype.inviteSetup = function inviteSetup(courseId, resultCb, errorCb) {
      return TraineesResource.get({courseId: courseId, type: 'invite-setup'}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    TraineesResource.prototype.inviteCourseTrainees = function inviteCourseTrainees(courseId, traineeIds, required, clientDatestamp, resultCb, errorCb) {
      return TraineesResource.save({courseId: courseId, type: 'invitation'}, {traineeIds:traineeIds, required: required, clientDatestamp: clientDatestamp}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    TraineesResource.prototype.inviteTraineesToCourse = function inviteTraineesToCourse(courseIds, traineeIds, required, clientDatestamp, version, resultCb, errorCb) {
      var payload = {
        traineeIds:traineeIds,
        courseIds: courseIds,
        required: required,
        clientDatestamp: clientDatestamp,
        version: version
      };

      return CourseTraineeInviteResoure.save(payload, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    TraineesResource.prototype.uninviteCourseTrainees = function uninviteCourseTrainees(courseId, traineeIds, resultCb, errorCb) {
      return TraineesDeleteResource.save({courseId: courseId, type: 'invitation'}, {traineeIds:traineeIds}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    TraineesResource.prototype.pokeRemindCourseTrainees = function pokeRemindCourseTrainees(courseId, traineeIds, resultCb, errorCb) {
      return TraineesResource.save({courseId: courseId, type: 'reminder'}, {traineeIds:traineeIds}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    TraineesResource.prototype.completeCourseTrainees = function completeCourseTrainees(courseId, traineeIds, resultCb, errorCb) {
      return CourseMicroServiceResource.save({courseId: courseId, action: 'complete'}, {traineeIds:traineeIds}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    TraineesResource.prototype.setTraineeScore = function setTraineeScore(courseId, traineeId, score, resultCb, errorCb) {
      return CourseMicroServiceResource.save({courseId: courseId, action: 'score'}, {traineeId:traineeId, score: score}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    TraineesResource.prototype.pokeRemindCourseTraineesByState = function pokeRemindCourseTrainees(courseId, state, resultCb, errorCb) {
      if (state != 'invited' && state != 'inProgress') {
        return errorCb(new Error("Cannot remind trainees in state '" + state + "'"));
      }
      return TraineesWithStateResource.save({courseId: courseId, type: 'reminder', state: state}, {}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    TraineesResource.prototype.updateTraineeRequiredInCourse = function updateTraineeRequiredInCourse(courseId, traineeId, required, resultCb, errorCb) {
      return TraineeResource.save({courseId: courseId, traineeId:traineeId, type: 'required'}, {required: required}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    TraineesResource.prototype.getCourseTitle = function getCourseTitle(courseId, resultCb, errorCb){
      return TraineesResource.get({courseId: courseId, type: 'title'},  resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    TraineesResource.prototype.getCourseStatus = function getCourseStatus(courseId, resultCb, errorCb){
      return TraineesResource.get({courseId: courseId, type: 'status'}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    TraineesResource.prototype.retakeCourse = function retakeCourse(courseId, traineeIds, clientDatestamp, resultCb, errorCb) {
      var hasNewCourseInviteRoutesFeature = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.newCourseInviteRoutes);
      if (hasNewCourseInviteRoutesFeature)
        return CourseBulkMicroServiceResource.update({action: 'reset'}, {traineeIds: traineeIds, clientDatestamp: clientDatestamp, courseIds: [courseId]}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
      return TraineesResource.save({courseId: courseId, type: 'reset'}, {traineeIds: traineeIds, clientDatestamp: clientDatestamp}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    TraineesResource.prototype.retakeCourseByState = function retakeCourseByState(courseId, state, clientDatestamp, resultCb, errorCb) {
      if (state != 'missedCompletionDeadline' && state != 'failed' && state != 'passed') {
        return errorCb(new Error("Cannot reset trainees in state '" + state + "'"));
      }
      var hasNewCourseInviteRoutesFeature = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.newCourseInviteRoutes);
      if (hasNewCourseInviteRoutesFeature)
        return CourseMicroServiceTraineesByStateResource.save({courseId: courseId, action: 'reset', state: state}, {clientDatestamp: clientDatestamp}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
      return TraineesWithStateResource.save({courseId: courseId, type: 'reset', state: state}, {clientDatestamp: clientDatestamp}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    TraineesResource.prototype.updateDeadline = function updateDeadline(courseId, traineeIds, deadlineDateTimestamp, resultCb, errorCb) {
        return TraineesResource.save({courseId: courseId, type: 'completionDeadline'}, {traineeIds:traineeIds, deadlineDateTimestamp: deadlineDateTimestamp}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    return new TraineesResource;
  }]);
